<template lang="html">
  <div>
    <div
      class="axiox"
      ref="axiox"
      @mousemove="searchUnderCoursor($event)"
      @click="clicking()"
      @mouseover="clear()">
      <div id="highter" />
      <div id="background" />
      <div class="component" id="block" />
      <div class="component" id="computer" />
      <div class="group" id="modules">
        <div id="module1" />
        <div id="module2" />
        <div id="module3" />
        <div id="module4" />
        <div id="module5" />
        <div id="module6" />
        <div id="module7" />
        <div id="module8" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['callback', 'clicking'],
  data: () => ({
    object: null,
    selected: null
  }),
  methods: {
    clear () {
      this.selected = null
    },
    searchUnderCoursor (event) {
      const target = event.target
      // console.log(target);
      let id = null
      // console.log(target.className);
      if (target.parentNode.className === 'group') {
        id = target.parentNode.id
      } else if (target.className === 'component') {
        id = target.id
      }
      this.selected = id
      if (this.callback) this.callback(id)
    }
  },
  mounted () {
    this.object = this.$refs.axiox
  }
}
</script>

<style lang="css" scoped>
  /* div {  } */
  .axiox {
    width: 100%;
    position: relative;
    /* height: 100%; */
    border: 1px solid rgba(0,0,0,0);
  }
  .axiox * {
    transition: .3s;
  }
  .component, .group {
    opacity: 0;
  }
  .component:hover, .component:active {
    opacity: 1;
    transform: scale(1.1);
  }
  .group:hover {
    opacity: 1;
  }
  .group *:hover {
    transform: scale(1.3);
  }
  .group,
  #highter {
    margin-top: 80%;
    border: 0;
  }
  #background {
    background: url(../assets/img/axiox/background.png) no-repeat;
    background-size: contain;
    opacity: 1;
  }
  .axiox:hover #background {
    opacity: 0.5;
  }
  #block {
    background: url(../assets/img/axiox/block.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 82.6%;
    top: 22.5%;
    width: 15.1%;
    height: 56.625%;
  }
  #background {
    background: url(../assets/img/axiox/background.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 3.6%;
    top: 4.5%;
    width: 94.1%;
    height: 90.5%;
  }
  #computer {
    background: url(../assets/img/axiox/computer.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 19.8%;
    top: 69.375%;
    width: 18.6%;
    height: 18%;
  }
  #module1 {
    background: url(../assets/img/axiox/module1.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 24.3%;
    top: 6.5%;
    width: 7.2%;
    height: 23.625%;
  }
  #module2 {
    background: url(../assets/img/axiox/module2.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 40.1%;
    top: 6.5%;
    width: 6.1%;
    height: 23.5%;
  }
  #module3 {
    background: url(../assets/img/axiox/module3.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 55.6%;
    top: 6.375%;
    width: 6.2%;
    height: 23.75%;
  }
  #module4 {
    background: url(../assets/img/axiox/module4.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 24.3%;
    top: 38.875%;
    width: 7.2%;
    height: 21.875%;
  }
  #module5 {
    background: url(../assets/img/axiox/module5.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 40.2%;
    top: 38.875%;
    width: 6.1%;
    height: 21.875%;
  }
  #module6 {
    background: url(../assets/img/axiox/module6.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 56%;
    top: 38.875%;
    width: 5.7%;
    height: 22%;
  }
  #module7 {
    background: url(../assets/img/axiox/module7.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 44.6%;
    top: 69.625%;
    width: 5.9%;
    height: 23.625%;
  }
  #module8 {
    background: url(../assets/img/axiox/module8.png) no-repeat;
    background-size: contain;
    position: absolute;
    left: 59.8%;
    top: 69.75%;
    width: 6.4%;
    height: 23.375%;
  }
</style>
